import { render, staticRenderFns } from "./ProductionItem.vue?vue&type=template&id=cd20e292&"
import script from "./ProductionItem.vue?vue&type=script&lang=js&"
export * from "./ProductionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductionItem.vue"
export default component.exports